import React from "react"
import clsx from "clsx"
import { MagnifyingGlassIcon } from "@phosphor-icons/react"

const SearchBar = ({ 
	placeHolder = 'SEARCH',
	rounded = false, 
	iconClass = '',
	id, 
	value, 
	onChange
 }) => {
	return (
		<React.Fragment>
			<div className={clsx('w-full relative flex flex-nowrap flex-1 items-center border border-solid border-neutral-400 bg-transparent bg-clip-padding focus-within:border-primary focus-within:border-2 focus-within:shadow-inset focus-within:outline-none  focus:z-[3] dark:focus-within:border-primary', rounded && 'rounded-full')}>
				<input
					type="search"
					className={clsx('relative m-0 mx-2 w-full block flex-auto px-3 py-[0.55rem] text-base border-none font-normal leading-[1.6] text-surface outline-none transition duration-200 ease-in-out hover:border-black placeholder:text-neutral-500 motion-reduce:transition-none dark:border-black/10 dark:text-black dark:placeholder:text-black-400 dark:autofill:shadow-autofill', rounded && 'rounded-full')}
					placeholder={placeHolder}
					aria-label="SEARCH"
					id={id}
					aria-describedby="button-addon2"
					value={value}
					onChange={onChange}
				/>
				<MagnifyingGlassIcon
					className={`pointer-events-none right-0 mr-4 ${iconClass}`}
					size={20}
				/>
			</div>
		</React.Fragment>
	)
}

export default SearchBar
